import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TileDetailView from "../views/Tile/TileDetailView";
import { useDispatch, useSelector } from "../../store";
import { clearLoadingState, getTable, getTileDetail } from "../../slices/tile";
import TileHeaderView from "../views/Tile/TileHeaderView";

interface Props {}

const TileDetailPage: React.FC<Props> = (props) => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tile, tileTable, tableSearchParams } = useSelector(
    (store) => store.tiles
  );

  useEffect(() => {
    if (!id) {
      navigate(`/dashboard`);
    }

    return () => {
      dispatch(clearLoadingState({}));
    };
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (!!id && (!tile || +id !== tile?.id)) {
      dispatch(getTileDetail(+id!));
    }

    return () => {
      dispatch(clearLoadingState({}));
    };
  }, [dispatch, id, tile]);

  useEffect(() => {
    if (!!id && (!tileTable || +id !== tileTable?.id)) {
      dispatch(
        getTable({
          search: { id: +id, pageNumber: 1, pageSize: 10, orderBy: "" },
        })
      );
    }

    return () => {
      dispatch(clearLoadingState({}));
    };
  }, [dispatch, id, tableSearchParams, tileTable]);

  return (
    <Box paddingTop={2} display="flex" flexDirection="column">
      <TileHeaderView id={+id!} />
      <TileDetailView />
    </Box>
  );
};

export default TileDetailPage;
